import React, { useEffect, useState } from "react";
import Menu from "../components/Header/Menu";
import {
    getLoggedUserDetails, getLoginLogoutUserStatus, getUserProfilePic, loadUserDetails, getCurrentUser,
    loadUserProfileLogo, loadUserProfilePic, loginLogoutStatusReceived, loginLogoutUpdateStatus, loginStatusUpdate,
    getLoggedPartnerUserDetails,
    loadPartnerUserDetails
} from "../store/auth";
import { useDispatch, useSelector } from "react-redux";
import ChangePassword from "../../Components/ChangePassword";
import Help from "../../Components/Support/Help";
import SupportPupup from "../../Components/Support/SupportPopup";
import AddSecurityQuestion from "../../Components/ApplicantProcessing/AddSecurityQuestion";
import Profile from "../../Components/Comman/Profile";
import { getFilterAllCandidates } from "../store/candidate";
import WelcomePage from "../../Components/WelcomePage";
import { useNavigate } from "react-router-dom";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../store/layoutUI";
import config from "../../config.json"
import { getFieldData } from "../../Services/appService";

const TopMenu = () => {

    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [welShowHide, setWelShowHide] = useState(false)
    const [helpDocs, setHelpDocs] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [logoutProcess, setLogoutProcess] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
    const userProfilePicSelector = useSelector(getUserProfilePic);
    const candidateSelector = useSelector(getFilterAllCandidates);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const pageTitleSelector = useSelector(getPageTitle);
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus);
    const partnerUserDetailsSelector = useSelector(getLoggedPartnerUserDetails);

    const dispatch = useDispatch();
    const navigate = useNavigate()
    const currentUser = getCurrentUser()

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser) {
            if (!partnerUserDetailsSelector && currentUser?.id)
                dispatch(loadPartnerUserDetails(usrId));
        } else {
            if (!userDetailsSelector && currentUser?.id)
                dispatch(loadUserDetails(currentUser.id));
        }
    }, []);

    useEffect(() => {
        if (usrType === "recruiter") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.RecruiterDoc))
        } else if (usrType === "subcontractor") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.SubcontractorDoc))
        } else {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.CandidateDoc))
        }
    }, [])

    useEffect(() => {
        if (workbenchHelpDocsSelector) {
            //const url = URL.createObjectURL(workbenchHelpDocsSelector);
            setHelpDocs(workbenchHelpDocsSelector)
        }

    }, [workbenchHelpDocsSelector])

    // useEffect(() => {
    //     if (loggedUserDetailsSelector?.maxtasks === null && currentUser) {
    //         dispatch(loginStatusUpdate(currentUser.id))
    //         setFirstLogin(true)
    //         setSecurityShowHide(true);
    //     } else if (loggedUserDetailsSelector?.maxtasks === 1) {
    //         dispatch(loginStatusUpdate(currentUser.id))
    //         setWelShowHide(true)
    //     } else {
    //         setFirstLogin(false)
    //     }
    //     setUserDetails(loggedUserDetailsSelector)
    // }, [loggedUserDetailsSelector]);

    const handleWelShowHide = () => {
        setWelShowHide(prev => !prev)
    }

    useEffect(() => {
        if (userDetailsSelector && !currentUser.linkUser) {
            setUserDetails(userDetailsSelector);

            dispatch(loadUserProfilePic(currentUser.id));

            let usrId = currentUser.id;
            if (currentUser.linkUser)
                usrId = currentUser.linkUser;
            if (currentUser?.id) {
                dispatch(loadUserProfileLogo(usrId));
            }

            if (userDetailsSelector?.maxtasks === null && currentUser) {
                dispatch(loginStatusUpdate(currentUser.id))
                setFirstLogin(true)
                setSecurityShowHide(true);
            } else if (userDetailsSelector?.maxtasks === 1) {
                dispatch(loginStatusUpdate(currentUser.id))
                setWelShowHide(true)
            } else {
                setFirstLogin(false)
            }
        }
    }, [userDetailsSelector]);

    useEffect(() => {
        if (partnerUserDetailsSelector) {
            setUserDetails(partnerUserDetailsSelector);
            // if (!partnerUserDetailsSelector && currentUser?.id)
            dispatch(loadUserProfilePic(currentUser.id));

            if (currentUser.id) {
                let usrId = currentUser.id;
                if (currentUser.linkUser) usrId = currentUser.linkUser;
                dispatch(loadUserProfileLogo(usrId));
            }

            if (partnerUserDetailsSelector?.maxtasks === null && currentUser) {
                dispatch(loginStatusUpdate(currentUser.id))
                setFirstLogin(true)
                setSecurityShowHide(true);
            } else if (partnerUserDetailsSelector?.maxtasks === 1) {
                dispatch(loginStatusUpdate(currentUser.id))
                setWelShowHide(true)
            } else {
                setFirstLogin(false)
            }
        }
    }, [partnerUserDetailsSelector]);

    useEffect(() => {
        if (userProfilePicSelector) {
            // let objectURL = 'data:image/jpeg;base64,' + userProfilePicSelector;
            let objectURL = process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + userProfilePicSelector;
            setProfilePicData(objectURL);
        }

    }, [userProfilePicSelector])

    let usrType = localStorage.getItem("userType");

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleModalShowHide = () => {
        setShowHide(!showHide);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide(!helpShowHide);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide(!issueShowHide);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide(!securityShowHide);
    };

    const handleProfileShowHide = () => {
        setProfileShowHide(!profileShowHide);
    };

    const handleCurrentTask = async (wiid) => {
        // const { data: workflowTask } = await http.get(
        //   config.GetWorkflowTask + wiid
        // );
        // if (workflowTask.formId > 0) {
        //   if (workflowTask.formType === "CF") {
        //     this.props.history.push({
        //       pathname: "/" + workflowTask.formName,
        //       state: { workflowTask },
        //     });
        //   } else {
        //     this.props.history.push({
        //       pathname: "/DynamicHtmlForm",
        //       state: { workflowTask },
        //     });
        //   }
        // }
    };

    const handleWorkflowTask = (data) => {
        // this.props.history.push({
        //   pathname: "/DynamicHtmlForm",
        //   state: { workflowTask: data },
        // });
    };

    const handleLogout = async () => {
        if (currentUser?.id) {
            setLogoutProcess(true);
            dispatch(loginLogoutUpdateStatus(currentUser.id));
        }
    }

    useEffect(() => {
        if (loginLogoutUserStatusSelector) {
            setLogoutProcess(false);
            //dispatch(loginLogoutStatusReceived(false))
            window.location = "/login";
        }
    }, [loginLogoutUserStatusSelector])

    let $imagePreview = null;
    $imagePreview = <img
        alt="profile" className="img-thumbnail rounded-circle" style={{ height: "60px", width: "60px" }}
        src={`${!profilePicData ? "../../assets/img/theme/team-4.png" : process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData}`}
    />

    return <>
        <div className="row">
            <div
                className="col-md-8 p-3"
            >
                <img
                    src={`/assets/Img/logo.png`}
                    alt=""
                    style={{
                        height: "80px",
                    }}
                />
            </div>
            <div className="col-md-4 p-3 d-flex justify-content-end">
                <nav className="navbar navbar-top navbar-expand navbar-dark p-0">
                    <div className="collapse navbar-collapse"
                        id="navbarSupportedContent"
                    >

                        <ul className="navbar-nav align-items-center ml-auto ml-md-0">
                            <li className="nav-item dropdown">
                                <button
                                    className="nav-link pr-0"
                                    href="#"
                                    data-toggle="dropdown"
                                    aria-expanded={isDropdownOpen}
                                    onClick={toggleDropdown}
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                        border: "none",
                                        backgroundColor: "transparent",
                                        outline: "none",
                                        textAlign: "left",
                                    }}
                                >
                                    <div className="media align-items-center">
                                        <span className="avatar rounded-circle">
                                            {profilePicData ?
                                                <img
                                                    alt="Placeholder"
                                                    className="img-thumbnail rounded-circle"
                                                    src={profilePicData}
                                                /> : <img
                                                    alt="Placeholder"
                                                    className="img-thumbnail rounded-circle"
                                                    src="../../assets/img/theme/team-4.png"
                                                />}
                                        </span>

                                        {currentUser && <div className="media-body ml-2 d-none d-lg-block">
                                            <span className="mb-0 text-sm font-weight-bold text-dark text-uppercase">
                                                <b>{userDetails?.performername} {userDetails?.lastName}</b>
                                            </span>
                                            <h5 className="text-dark">
                                                Reg ID : {currentUser?.id}
                                                <br />
                                                Role : {usrType !== "candidate" ? currentUser.linkUser ? currentUser.role : userDetailsSelector?.title : getFieldData(
                                                    userDetailsSelector?.performerData,
                                                    "projectengagement",
                                                    "PositionTitle"
                                                )}
                                                <br />

                                                Last Login : {(new Date()).toDateString()}
                                            </h5>
                                        </div>}
                                    </div>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <button className="dropdown-item"
                                        onClick={handleProfileShowHide}
                                    >
                                        <i className="ni ni-single-02" />
                                        <span>My Profile</span>
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={handleModalShowHide}
                                    >
                                        <i className="ni ni-settings-gear-65" />
                                        <span>Change Password</span>
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={handleSecurityShowHide}
                                    >
                                        <i className="fa fa-shield" />
                                        <span>Change Security Questions</span>
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={handleHelpShowHide}
                                    >
                                        <i className="ni ni-support-16" />
                                        <span>Help</span>
                                    </button>

                                    <div className="dropdown-divider" />

                                    <button
                                        className="dropdown-item"
                                        onClick={handleLogout}
                                        disabled={logoutProcess}
                                    >
                                        {logoutProcess ? <i className="fa fa-spinner fa-spin"></i> : <i className="ni ni-user-run" />}Logout
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
        <div className="row border pt-2 pb-2">
            <div className="col-md-2">
                <button className="btn btn-sm btn-outline-default text-capitalize">
                    {usrType} Portal
                </button>
            </div>
            <div className="col-md-4 text-right pl-2">

            </div>
            <div className="col-md-6 text-right">
                <button
                    onClick={() => setWelShowHide(true)}
                    className="btn btn-sm btn-outline-default m-0 mr-2"
                >
                    Welcome Letter
                </button>
                <button
                    onClick={handleIssueShowHide}
                    className="btn btn-sm btn-outline-default m-0 mr-2"
                    title="Any defects/issues found in the Portal can be registered in the Customer Support Portal."
                >
                    <i className="fa fa-support"></i> Customer Support
                </button>
                <button
                    onClick={() => handleHelpShowHide()}
                    className="btn btn-sm btn-outline-default m-0 mr-2"
                    title="Welcome Letter"
                >
                    Help
                </button>

                <button
                    className="btn btn-sm btn-outline-default m-0"
                    onClick={handleLogout}
                    disabled={logoutProcess}
                >
                    {logoutProcess ? <i className="fa fa-spinner fa-spin"></i> : <i className="ni ni-user-run" />} Logout
                </button>
            </div>
        </div>
        <div className="row border-bottom pb-1">
            <div className="col-12 text-center">
                <span className="h2 text-dark">
                    NEXT GENERATION HUMAN RESOURCE ONBOARDING, CONTRACT, TIME LOG AND INVOICING SYSTEM
                </span>
            </div>
        </div>
        {showHide &&
            <ChangePassword
                handleModalShowHide={handleModalShowHide}
                showHide={showHide}
            ></ChangePassword>}
        {profileShowHide &&
            <Profile
                handleProfileShowHide={handleProfileShowHide}
                profileShowHide={profileShowHide}
                usrType={usrType}
            ></Profile>}
        {helpShowHide &&
            <Help
                helpShowHide={helpShowHide}
                handleHelpShowHide={handleHelpShowHide}
                module={pageTitleSelector}
                helpDocs={helpDocs}
            ></Help>}
        {issueShowHide &&
            <SupportPupup
                handleIssueShowHide={handleIssueShowHide}
                issueShowHide={issueShowHide}
                handleCurrentTask={handleCurrentTask}
                handleWorkflowTask={handleWorkflowTask}
            ></SupportPupup>}

        {securityShowHide && <AddSecurityQuestion
            firstLogin={firstLogin}
            securityShowHide={securityShowHide}
            handleSecurityShowHide={handleSecurityShowHide}
            userDetails={userDetails}
        ></AddSecurityQuestion>}
        {welShowHide && <WelcomePage
            userDetails={userDetails}
            welShowHide={welShowHide}
            handleWelShowHide={handleWelShowHide}
        ></WelcomePage>}

    </>
}

export default TopMenu;